import Radio from './radio';
import RadioGroup from './radio-group';

Radio.Group = RadioGroup;

export default Radio;
